import React, { useEffect, useRef, useState } from 'react';
import './print-secret-codes.styles.scss';
import { useSelector } from 'react-redux';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { getCollectionFromDb, getGameDataFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import { useParams } from 'react-router-dom';
import { ModalAlert } from '@/components/modal/modal.component';
import Loader from '@/components/loader/loader.comp';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';

const PrintSecretCodes = () => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [ secretCodes, setSecretCodes ] = useState(null);
  const [ gameData, setGameData ] = useState(null);
  const [ hasAccess, setHasAccess ] = useState(false);
  const [ alertMessage, setAlertMessage ] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const { gamePath } = useParams();
  const codesRef = useRef([]);

  useEffect(() => {
    if (!userProfile && gamePath) return;
    getGameData();
  }, [userProfile, gamePath])

  useEffect(() => {
    if (!hasAccess) return;
    
  }, [hasAccess])

  async function getGameData() {
    getGameDataFromDb({
      'gamePath': gamePath,
      'once': true,
      'callback': callback
    })
    function callback(data) {
      console.log(data);
      if (data && Object.values(data)[0].gameId) {
        checkForManagmentAccess(Object.values(data)[0].gameId);
        setGameData(Object.values(data)[0]);
      }
    }
    
  }

  async function checkForManagmentAccess(gameId) {
    if (location.pathname.includes('/preview/manager/')) {
          setAlertMessage('Sorry! You cannot access this page in Preview Mode.');
          return;
    }
    const res = await UseCloudFunction(
      'checkManagerAccess',
      { 
        'appId': userProfile.appId,
        'gameId': gameId
      }
    )
    console.log(res);
    if (res.error) {
      setHasAccess(false);
      setAlertMessage(`Something went wrong. (Error: ${res.error.message})`);
      return;
    }
    if (res.denied) {
      setHasAccess(false);
      setAlertMessage(`You do not have permission to access this page.`);
      return;
    }
    if (res.success) {
      setHasAccess(true);
      fetchSecretCodes(gameId);
    }
  }

  function fetchSecretCodes(gameId) {
    codesRef.current = [];
    getCollectionFromDb({
      'collection': `games/${gameId}/gameElements`,
      'query1': {
        'key': 'type', 
        'condition': '==', 
        'value': 'secretCode'
      },
      'once': true,
      'callback': callback
    })
    function callback(data) {
      console.log(data);
      codesRef.current = [...codesRef.current, ...[data]];
      setSecretCodes(codesRef.current);
      setLoading(false);
    }
  }

  function printPage() {
        window.print();
    }

  return (
    <div className={`print-secret-codes ${screenSize}`}>
      <div className='print-secret-codes-content'>
        {
          (loading)
            ?
            <div className='loader-div'>
              <Loader show={true} />
              {/* <FullPageLoader show={true} /> */}
            </div>
            :
            (hasAccess && secretCodes && gameData)
              ?
              <div>
                <div id='print-button'>
                  <div className="g-space-2"></div>
                  <div className='buttons'>
                    {/* <div className='field'>
                      <select
                        className='g-select'
                        onChange={(e) => setPlayers(sortPlayers({
                          'playerList': players,
                          'filter': 'players',
                          'sortBy': e.target.value
                        }))}>
                        <option value=''>Sort Players...</option>
                        <option value='name'>By Name</option>
                        <option value='playerInfo'>By Player Info</option>
                      </select>
                    </div> */}
                    <button

                      className='g-button'
                      onClick={() => printPage()}
                    >
                      Print Code Cards
                    </button>
                  </div>
                  <div className="g-space-2"></div>
                </div>
                <div className='codes-list'>
                  {
                   secretCodes
                   .sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
                   .map((code, index) => (
                      <div 
                        key={code.id} 
                        className={`g-list-item code-card ${(index + 1) % 6 === 0 ? 'break' : ''}`} >
                          {/* <img 
                            src={gameData.header}
                            className='header' /> */}
                          <p>You found a Secret Code!</p>
                          
                          <div className='icon-div'>
                            <h1 >{code.name}</h1>
                            <ImageContainer 
                              src={gameData.icon}
                              className='icon'  />
                            
                          </div>
                          <p className='meta'>{gameData.gameName}</p>
                          <p>{code.desc ?? ''}</p>
                        </div>
                    ))
                  }
                </div>
              </div>
              :
              <h3>No Secret Codes found</h3>
        }
      </div>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
      />
    </div>
  )
}

export default PrintSecretCodes